import { Accordion, AccordionDetails, AccordionSummary, Box, colors, FormControl, Paper, styled, SxProps, Tabs, Typography, useTheme } from "@mui/material";
import { MiscSavio, StyleguideSavioColors, StyleguideSavioFonts } from "../../../configuration/themeSettings";
import CommonDialog from "../../../components/CommonDialog/CommonDialog";
import { DrawerWithoutBackground } from "../../../components/PartDetails/DrawerPart/DrawerPartDetails.styles";


export const AccordionStyled = styled(Accordion, { label: "offer_order_history_filter-AccordionStyled" })
    (({ theme }) => ({

        color: StyleguideSavioColors.mainBlue,
        display: 'flex',
        flexDirection: 'column',
        marginTop: '0 !important',
        boxShadow: 'none',


        '> h3': {
            display: 'flex', boxShadow: 'none',
            height: 60,
            justifyContent: 'right',
            width: '100%',
            alignItems: 'center',
            'button': { alignItems: 'center', },
            'svg': { fontSize: 20, marginTop: -2, },
            'p': { fontSize: 14, textTransform: 'uppercase', },

            '+ div': { margin: 0, }
        }

    }))



export const AccordionSummaryStyled = styled(AccordionSummary, { label: "offer_order_history_filter-AccordionSummaryStyled" })
    (({ theme }) => ({

        flexDirection: 'row-reverse',
        boxShadow: 'none',
        padding: 0,

        "> div": {
            flexGrow: 'initial', marginRight: 8,
        }

    }))

export const AccordionDetailsStyled = styled(AccordionDetails, { label: "offer_order_history_filter-AccordionDetailsStyled" })
    (({ theme }) => ({


        marginLeft: -30,
        marginRight: -24,
        paddingBottom: 14,
        textAlign: 'left',


        '> div': {
            width: 'calc(25% - 60px)',
            margin: '10px 30px',

            '&:last-child': {
                width: 'calc(100% - 30px)',
                justifyContent: 'flex-end',
                margin: 0,
                marginTop: 30,
            }
        }

    }))

    export const FormControlStyled = styled(FormControl, { label: "offer_order_history_filter-FormControlStyled" })
    (({ theme }) => ({


        '> label':{
            transform: 'translate(0px, 19px) scale(1) !important',

            '&.MuiInputLabel-shrink':{
                transform: 'translate(0px, 0px) scale(1) !important',
            }
        }
       

    }))
